package com.karawek.core.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun <T> CoreDropdown(
    value: T?,
    onValueChange: (T) -> Unit,
    options: List<T>,
    label: String,
    placeholder: String = "",
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    error: String? = null,
    itemLabel: (T) -> String = { it.toString() },
) {
    var expanded by remember { mutableStateOf(false) }

    OutlinedTextField(
        value = value?.let(itemLabel) ?: "",
        onValueChange = {},
        label = { Text(label) },
        placeholder = { Text(placeholder) },
        modifier = modifier.clickable(enabled = enabled) { expanded = true },
        enabled = false,
        readOnly = true,
        isError = error != null,
        textStyle = CoreTypography.body,
        supportingText = {
            error?.let {
                Text(
                    text = it,
                    style = CoreTypography.caption,
                    color = CoreTheme.colors.error,
                )
            }
        },
        colors = androidx.compose.material3.OutlinedTextFieldDefaults.colors(
            disabledTextColor = CoreTheme.colors.textPrimary.copy(alpha = CoreAlphas.Disabled),
            disabledBorderColor = if (error != null) CoreTheme.colors.error else CoreTheme.colors.divider,
            disabledLabelColor = if (error != null) {
                CoreTheme.colors.error.copy(alpha = CoreAlphas.Disabled)
            } else {
                CoreTheme.colors.textSecondary.copy(alpha = CoreAlphas.Disabled)
            },
            disabledPlaceholderColor = CoreTheme.colors.textSecondary.copy(alpha = CoreAlphas.Disabled),
        ),
    )

    DropdownMenu(
        expanded = expanded,
        onDismissRequest = { expanded = false },
    ) {
        options.forEach { option ->
            DropdownMenuItem(
                text = { Text(itemLabel(option)) },
                onClick = {
                    onValueChange(option)
                    expanded = false
                },
            )
        }
    }
}
